import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getDSDVKhacDaChiDinh } from 'src/app/modules/phan-he-kham-benh/services/ChiDinhDVService';
import ListDonThuoc from 'src/app/modules/phan-he-kham-benh/tabs/tab-thuoc/components/table-don-thuoc/TableDonThuoc';
import { RESPONSE_MESSAGE } from 'src/app/modules//utils/Constant';
import { LOAI_BENH_AN } from 'src/app/modules/phan-he-kham-benh/constants/BenhAn';
import { useBenhAnContext } from 'src/app/modules/phan-he-kham-benh/contexts/BenhAnContext';
import ThongTinPhieu from '../phieu-xet-nghiem/components/ThongTinPhieu';
import { DANH_SACH_DICH_VU_KHAC_COLUMNS } from './constants';

const PhieuDichVuKhac = () => {
	const { phieuBenhAn } = useBenhAnContext();

	const [data, setData] = useState<any>();

	useEffect(() => {
		if (LOAI_BENH_AN.DICH_VU_KHAC === phieuBenhAn?.displayCode) {
			getDetailPhieu();
		}
	}, [phieuBenhAn?.id, phieuBenhAn?.displayCode]);

	const getDetailPhieu = async () => {
		try {
			const { data } = await getDSDVKhacDaChiDinh({
				orderGroupId: phieuBenhAn?.id,
			});

			setData({
				...phieuBenhAn,
				terms: data.data,
			});
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	return (
		<div className="spaces p-10">
			<ThongTinPhieu data={data} />
			<ListDonThuoc data={data?.terms || []} columns={DANH_SACH_DICH_VU_KHAC_COLUMNS} />
		</div>
	);
};

export default PhieuDichVuKhac;
